<template>
  <div class="ui large modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="sign in icon"></i>
      {{ $t("inventory input") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img
          src="/images/icons/inventory-in.png"
          style="width: 100% !important"
        />
      </div>
      <div class="description" style="width: 100%">
        <div class="ui two item pointing menu" ref="tabs">
          <a class="item active" data-tab="general">
            <i class="circle info icon"></i>
            {{ $t("general information") }}
          </a>
          <a class="item" data-tab="images">
            <i class="picture icon"></i>
            {{ $t("images") }}
          </a>
        </div>
        <div class="ui tab segment active" data-tab="general">
          <div class="ui form" ref="form">
            <div class="two fields" v-bind:class="{ disabled: !is_editable }">
              <div class="field">
                <label for>{{ $t("reason") }}</label>
                <div class="ui selection dropdown" ref="reason_dropdown">
                  <input type="hidden" name="reason" />
                  <i class="dropdown icon"></i>
                  <div class="default text">{{ $t("reason") }}</div>
                  <div class="menu"></div>
                </div>
              </div>
              <div class="field">
                <label for>{{ $t("description") }}</label>
                <textarea
                  name="description"
                  rows="2"
                  v-model="input.description"
                ></textarea>
              </div>
            </div>

            <div class="two fields">
              <div
                class="field"
                v-for="(attr, index) in input_attributes"
                :key="index"
              >
                <label for>{{ attr.name }}</label>
                <input type="text" v-model="input_attributes[index].value" />
              </div>
            </div>

            <h4 class="ui dividing header">{{ $t("product list") }}</h4>
            <div class="fields">
              <div class="two wide column field"></div>
              <div class="two wide column field">
                <label for>{{ $t("quantity") }}</label>
              </div>
              <div class="four wide column field">
                <label for>{{ $t("product") }}</label>
              </div>
              <div class="five wide column field">
                <label style="display: inline-block">{{
                  $t("provider")
                }}</label>
                <div
                  class="ui toggle right floated checkbox"
                  style="margin: 0; float: right"
                >
                  <input
                    type="checkbox"
                    name="public"
                    v-model="use_same_provider"
                  />
                  <label>{{ $t("use same provider") }}</label>
                </div>
              </div>
              <div class="three wide column field">
                <label for>{{ $t("expiration date") }}</label>
              </div>
            </div>
            <div
              class="fields"
              v-for="(product, index) in products"
              :key="index"
              v-bind:class="{ disabled: !is_editable }"
              style="margin-bottom: 5px"
            >
              <div class="two wide column field">
                <div class="ui mini buttons">
                  <div
                    class="ui green mini icon button"
                    @click="add_product"
                    v-if="index == products.length - 1"
                  >
                    <i class="plus icon"></i>
                  </div>
                  <div
                    class="ui red mini icon button"
                    @click="remove_product(product, index)"
                    v-if="index > 0"
                  >
                    <i class="trash icon"></i>
                  </div>
                  <div
                    class="ui orange mini icon button"
                    ref="configure_button"
                    v-if="product_attributes.length > 0"
                  >
                    <i class="setting icon"></i>
                  </div>
                </div>

                <div
                  class="ui flowing popup left center transition hidden"
                  ref="configure_popup"
                >
                  <div class="ui two column divided grid">
                    <div
                      class="column"
                      v-for="(attr, idx) in product.attributes"
                      :key="idx"
                    >
                      <h4 class="ui header">{{ attr.name }}</h4>
                      <input
                        type="text"
                        v-model="products[index].attributes[idx].value"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="two wide column field">
                <input
                  type="text"
                  name="quantity"
                  v-model="products[index].quantity"
                />
              </div>
              <!-- <div class="four wide column field">
              <div class="ui search selection dropdown" ref="product_dropdown" :data-i="index">
                <input type="hidden" name="product" />
                <i class="dropdown icon"></i>
                <div class="default text">{{ $t("product") }}</div>
                <div class="menu"></div>
              </div>
            </div>-->
              <div class="four wide column field">
                <div
                  class="ui blue search"
                  ref="product_search"
                  :data-i="index"
                >
                  <div class="ui icon input">
                    <input
                      class="prompt"
                      type="text"
                      :placeholder="$t('search product')"
                      v-model="products[index].product.name"
                    />
                    <i class="search icon"></i>
                  </div>
                  <div class="results"></div>
                </div>
              </div>
              <div class="five wide column field">
                <div
                  class="ui search selection dropdown"
                  :class="{ disabled: use_same_provider && index != 0 }"
                  ref="provider_dropdown"
                  :data-i="index"
                >
                  <input type="hidden" name="provider" />
                  <i class="dropdown icon"></i>
                  <div class="default text">{{ $t("provider") }}</div>
                  <div class="menu"></div>
                </div>
              </div>
              <div class="three wide column field">
                <div class="ui calendar" ref="calendar" :data-i="index">
                  <div class="ui input left icon">
                    <i class="calendar icon"></i>
                    <input
                      type="text"
                      name="date"
                      v-model="products[index].expiration_date"
                      :placeholder="$t('date')"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="ui error message"></div>
          </div>
        </div>
        <div class="ui tab segment" data-tab="images">
          <h4 class="ui dividing header">{{ $t("images") }}</h4>
          <file-pond
            name="file"
            ref="pond"
            :label-idle="$t('click or drop files here')"
            v-bind:allow-multiple="true"
            v-bind:allow-revert="false"
            v-bind:server="{
              url: api_host,
              timeout: enterprise_setup.upload_timeout,
              process: {
                url: '/inventory/do-upload-input-image',
                method: 'POST',
                headers: {
                  'x-access-token': token_session,
                },
                withCredentials: false,
              },
            }"
            v-on:error="filepond_error"
            v-on:processfile="filepond_process"
          />
          <div class="ui four cards">
            <div
              class="card"
              v-for="(img, idx) in input.document_images"
              :key="idx"
            >
              <div class="image">
                <img
                  v-img:name
                  class="ui image"
                  :src="resource_url(img.server_file)"
                />
              </div>
              <div class="ui bottom attached basic buttons">
                <div
                  :data-tooltip="$t('download')"
                  class="ui button"
                  @click.stop="download(img)"
                >
                  <i class="ui download icon"></i>
                </div>
                <div
                  :data-tooltip="$t('delete')"
                  class="ui button"
                  @click.stop="remove(img, idx)"
                >
                  <i class="ui red trash icon"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div
        class="ui left floated red icon right labeled button"
        v-if="uuid"
        @click="remove_input"
      >
        <i class="trash icon"></i>
        {{ $t("delete") }}
      </div>
      <div class="ui red icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <div class="ui blue icon right labeled button" @click="save">
        <i class="save icon"></i>
        {{ $t("save") }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  local_api,
  error_toast,
  enterprise_setup,
  api_host,
  download_resource,
} from "@/utils";
import vueFilePond from "vue-filepond";
import { cloneDeep } from "lodash";
import { v4 } from "uuid";
// import UserSearch from "@/components/UserSearch";
// import StaffSearch from "./StaffSearch";
// import GenericContainer from "@/components/GenericContainer";

const FilePond = vueFilePond();

export default {
  name: "InventoryInputInputModalIndex",
  components: {
    FilePond,
  },
  props: {},
  computed: {
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
    remove_visibility_condition() {
      if (this.input_in && this.input_in.uuid) return true;
      return false;
    },
  },
  data() {
    return {
      input_reasons: [],
      input: {
        reason: "",
        description: "",
        document_images: [],
      },
      products: [],
      all_products: [],
      api_host: api_host,
      input_attributes: [],
      product_attributes: [],
      uuid: undefined,
      providers: [],
      use_same_provider: false,
      is_editable: true,
    };
  },
  methods: {
    show_modal(data) {
      let vm = this;

      /**
       * get template
       */
      if (data && data.uuid) {
        // console.log(data);
        local_api(vm, "post", "/inventory/do-get-input", {
          u: data.uuid,
        })
          .then((inventory_input) => {
            // console.log("inventory_input", inventory_input);
            if (inventory_input) {
              vm.uuid = inventory_input.uuid;
              vm.input.reason = inventory_input.reason_uuid;
              vm.input.description = inventory_input.description;
              vm.input.document_images = JSON.parse(inventory_input.images);
              vm.input_attributes = JSON.parse(inventory_input.attributes);
              vm.products = inventory_input.inv_input_products.map((p) => {
                p.product = p.prd_product;
                // console.log(p.product);
                if (p.attributes) p.attributes = JSON.parse(p.attributes);
                return p;
              });

              // window
              //   .jQuery(vm.$refs.provider_dropdown)
              //   .dropdown("setup menu", { values: _vls });
            }
          })
          .catch((err) => {
            error_toast(err);
          });
        // console.log(data);
      }

      /** /get providers */
      local_api(vm, "post", "/provider/do-get-all")
        .then((r) => {
          if (r) {
            vm.providers = r;
            vm.init_provider_dropdown();
          }
        })
        .catch((err) => {
          error_toast(err);
        });

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            local_api(vm, "post", "/inventory/do-get-input-configuration")
              .then((r) => {
                if (r) {
                  vm.input_reasons = r.inputs;
                  let _vls = vm.input_reasons.map((r) => {
                    return {
                      name: r.name,
                      value: r.id,
                    };
                  });
                  window
                    .jQuery(vm.$refs.reason_dropdown)
                    .dropdown("setup menu", { values: _vls })
                    .dropdown({
                      onChange(value) {
                        vm.input.reason = value;
                        let targetReason = vm.input_reasons.find(
                          (n) => n.id == value,
                        );
                        if (targetReason && targetReason.reason_attributes) {
                          vm.input_attributes =
                            targetReason.reason_attributes.map((r) => {
                              r.value = "";
                              return r;
                            });

                          vm.product_attributes =
                            targetReason.product_attributes.map((r) => {
                              r.value = "";
                              return r;
                            });

                          if (vm.products.length == 0) vm.add_product();
                        }

                        // vm.init_provider_dropdown();
                      },
                    });

                  if (data && data.uuid) {
                    if (vm.input.reason)
                      window
                        .jQuery(vm.$refs.reason_dropdown)
                        .dropdown("set selected", vm.input.reason);
                  }
                }
              })
              .catch((err) => {
                error_toast(err);
              });

            window.jQuery(vm.$refs.tabs).find(".item").tab();
          },
          onHidden() {
            vm.uuid = "";
            vm.input = {
              reason: "",
              description: "",
              document_images: [],
            };
            vm.products = [];
            vm.product_attributes = [];
            window.jQuery(vm.$refs.reason_dropdown).dropdown("clear");
          },
        })
        .modal("show");

      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          id_number: ["empty"],
          first_name: ["empty"],
          surname: ["empty"],
          ucontact_user: ["empty"],
          soc_user: ["empty"],
          core_sys_user: ["empty"],
          printing_user: ["empty"],
        },
      });
    },
    save() {
      let vm = this;

      let isValid = window.jQuery(vm.$refs.form).form("validate form");

      if (isValid) {
        local_api(vm, "post", "/inventory/do-save-inventory-input", {
          r: vm.input.reason,
          a: vm.input_attributes,
          d: vm.input.description,
          i: vm.input.document_images,
          p: vm.products,
          u: vm.uuid,
        })
          .then(() => {
            window.jQuery(vm.$refs.modal).modal("hide");
            vm.$emit("success");
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
    // remove() {
    //   let vm = this;
    //   vm.$alertify.confirm(vm.$t("are you sure to remove staff?"), function () {
    //     local_api(vm, "post", "/multimoney_staff/admin/do-remove", {
    //       u: vm.uuid,
    //     })
    //       .then(() => {
    //         window.jQuery(vm.$refs.modal).modal("hide");
    //         vm.$emit("success");
    //       })
    //       .catch((err) => {
    //         error_toast(err);
    //       });
    //   });
    // },
    remove_product(product, index) {
      this.products.splice(index, 1);
    },
    add_product() {
      let vm = this;
      this.products.push({
        quantity: 1,
        attributes: cloneDeep(this.product_attributes),
        product: {},
      });
      setTimeout(() => {
        window.jQuery(vm.$refs.configure_button).each((index) => {
          window.jQuery(vm.$refs.configure_button[index]).popup({
            popup: window.jQuery(vm.$refs.configure_popup[index]),
            lastResort: "top center",
            on: "click",
          });
        });
      }, 200);
    },
    // init_product_dropdown() {
    //   let vm = this;
    //   let _vls = vm.all_products.map(p => {
    //     return {
    //       name: p.name,
    //       value: p.uuid
    //     };
    //   });

    //   setTimeout(() => {
    //     window
    //       .jQuery(vm.$refs.product_dropdown)
    //       .dropdown("setup menu", { values: _vls })
    //       .dropdown({
    //         onChange(value, text, $element) {
    //           let parent = $element.parent().parent();
    //           let index = parent.data("i");
    //           if (index >= 0)
    //             vm.products[index].product = { uuid: value, name: text };
    //         }
    //       });
    //   }, 100);
    // },
    init_provider_dropdown() {
      let vm = this;
      let _vls = vm.providers.map((p) => {
        return {
          name: p.name,
          value: p.provider_id,
        };
      });
      _vls.unshift({ name: vm.$t("select one"), value: "" });

      setTimeout(() => {
        // console.log("initing dropdown", _vls);
        window
          .jQuery(vm.$refs.provider_dropdown)
          .dropdown("setup menu", { values: _vls })
          .dropdown({
            onChange(value, text, $element) {
              let parent = $element.parent().parent();
              let index = parent.data("i");
              if (index >= 0)
                vm.products[index].provider = { id: value, name: text };
              if (index == 0 && vm.use_same_provider) {
                let prov = vm.products[index].provider;
                vm.products.map((p) => {
                  p.provider = prov;
                });
                // window
                //   .jQuery(vm.$refs.provider_dropdown)
                //   .dropdown("set selected", prov.id);
              }
            },
          });

        setTimeout(() => {
          // update providers dropdown
          // console.log("setting providers", vm.$refs.provider_dropdown);
          vm.$refs.provider_dropdown.map((prd) => {
            let indx = window.jQuery(prd).data("i");
            let trgtProdct = vm.products[indx];
            if (trgtProdct && trgtProdct.provider_id) {
              // console.log("setting selected", trgtProdct.provider_id, prd);
              window
                .jQuery(prd)
                .dropdown("set selected", trgtProdct.provider_id);
            }
          });
        }, 500);
      }, 100);
    },
    filepond_error(a, b) {
      console.log("error", a, b);
    },
    filepond_process(event, inst) {
      //let x1 = this.$refs.pond;
      // console.log(x1, inst);
      if (inst.serverId) {
        let r = JSON.parse(inst.serverId);
        if (!r.success) console.log(r.error);
        else {
          this.input.document_images.push({
            file_id: v4(),
            server_file: r.data,
            filename: inst.filename,
            filenameWithoutExtension: inst.filenameWithoutExtension,
            fileExtension: inst.fileExtension,
            fileType: inst.fileType,
            fileSize: inst.fileSize,
          });
        }
        // x1.removeFiles().then((r) => {
        //   console.log(r);
        // });
      }
    },
    resource_url(file_name) {
      return `${api_host}/public/uploads/inventory/input/${file_name}`;
    },
    download(image) {
      let url = `${api_host}/public/uploads/inventory/input/${image.server_file}`;
      download_resource(this, url, image.filename);
    },
    remove(image, index) {
      this.input.document_images.splice(index, 1);
    },
    init_product_search() {
      let vm = this;
      setTimeout(() => {
        window.jQuery(this.$refs.product_search).search({
          apiSettings: {
            action: "search product",
            beforeXHR: function (xhr) {
              let token = vm.$session.get("token");
              if (token) {
                xhr.setRequestHeader("x-access-token", token);
              }
              return xhr;
            },
            onResponse: function (response) {
              if (!response.success) vm.$alertify.error(response.error);
              else {
                var _response = {
                  results: [],
                };
                response.data.map((r) => {
                  _response.results.push({
                    title: r.name,
                    description: r.description,
                    product: r,
                  });
                });
                return _response;
              }
            },
          },
          onSelect(result) {
            let index = window.jQuery(this).data("i");
            if (index >= 0)
              vm.products[index].product = {
                uuid: result.product.uuid,
                name: result.product.name,
              };
          },
        });
      }, 100);
    },
    init_calendar() {
      let vm = this;
      setTimeout(function () {
        window.jQuery(vm.$refs.calendar).calendar({
          type: "date",
          today: true,
          onChange(date) {
            let idx = window.jQuery(this).data("i");
            if (idx > -1) vm.products[idx].expiration_date = date;
          },
        });
      }, 100);
    },
    remove_input() {
      let vm = this;
      if (vm.uuid)
        vm.$alertify.confirm(
          vm.$t("are you sure to remove inventory input?"),
          function () {
            local_api(vm, "post", "/inventory/do-remove-inventory-input", {
              u: vm.uuid,
            })
              .then(() => {
                window.jQuery(vm.$refs.modal).modal("hide");
                vm.$emit("success");
              })
              .catch((err) => {
                error_toast(err);
              });
          },
        );
    },
  },
  mounted() {
    // let vm = this;
    // local_api(vm, "post", "/multimoney_staff/admin/do-get-catalogs", {})
    //   .then((catalogs) => {
    //     if (catalogs) {
    //       vm.catalogs = catalogs;
    //     }
    //   })
    //   .catch((err) => {
    //     error_toast(err);
    //   });
  },
  watch: {
    products() {
      let vm = this;
      vm.init_provider_dropdown();
      vm.init_product_search();
      this.init_calendar();
    },
  },
  updated: function () {},
};
</script>
